import { setCookie } from "./cookiesActions";

export const STATE_CULTURE = "shop-culture";
export const STATE_ACTIVE_PERSON_ID = "booking-active-person-id";
export const THEME = "theme";

export const keys = () => {
  return [STATE_CULTURE, STATE_ACTIVE_PERSON_ID, THEME];
};

export const setActivePersonId = (id) => (dispatch) => {
  dispatch(setCookie(STATE_ACTIVE_PERSON_ID, id));
};
